// Centralised API service layer for Onward Referral.
// All api.transact calls are defined here so endpoint names live in one place.

export const getPostalAddresses = (api, partyID) =>
    api.transact('PostalAddressList', { partyid: partyID }).then(r => r.apiResult);

export const getPracticeRankings = (api) =>
    api.transact('PracticeRankingList', {}).then(r => r.apiResult);

export const getModalityList = (api) =>
    api.transact('GetModalityList', {}).then(r => r.apiResult);

export const getNotesToAP = (api, caseID) =>
    api.transact('GetNotesToAP', { CaseID: caseID }).then(r => r.apiResult);

export const getPractices = (api, params) =>
    api.transact('GetPractices', params).then(r => r.apiResult);

export const getClientReferrerAccess = (api, caseID, partyID) =>
    api.transact('GetClientReferrerAccess', { CaseID: caseID, PartyID: partyID })
        .then(r => JSON.parse(r.apiResult));

export const getBrandingInfo = (api, caseID) =>
    api.transact('GetBrandingInfo', { CaseID: caseID }).then(r => r.apiResult);

// Returns the full response — calling code reads r.apiResult.FacilityList, r.apiResult.ClosestIndex etc.
export const searchPractices = (api, params) =>
    api.transact('PracticeSearch', params);

export const sendMailToClinics = (api, payload) =>
    api.transact('SendMailToClinics', payload);

// Returns the full response — calling code reads r.apiStatus and r.apiText directly.
export const makeReferral = (api, params) =>
    api.transact('MakeReferral', params);
